import Vue from "vue";

/**
 * exibe toast por 5 segundos
 * @param {string} message mensagem
 * @param {("success"|"error")} type 
 */
const toast = (message, type, duration = 5000) => Vue.$toast.open({
    message: message ? message : "",
    type,
    position: "top-right",
    duration
});

export default toast;